import Section from '~/src/features/tariffBuilder/components/Section';
import CreateAgreementContainer from '~/src/features/tariffBuilder/containers/CreateAgreementContainer';

const CreateAgreement = (): JSX.Element => {
    return (
        <Section>
             <CreateAgreementContainer />
        </Section>
    );
};

export default CreateAgreement;
